module.exports = __webpack_public_path__ + "static/media/view6.6ee8aa6d.jpg";